import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsBackgroundImageModal,
  setIsLogoModal,
} from "../../../redux/slices/modals";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";
import {
  CustomCol,
  FrameItem,
} from "../../../page/ThirdScreen/qrSettings/framesQr/QrFrameItems";
import Accordion from "react-bootstrap/Accordion";
import classNames from "classnames";
import {
  defaultLogo,
  logoCategories,
} from "../../../page/ThirdScreen/qrSettings/logotypeQr/svg";
import {
  qrLogotype,
  setBackgroundImage,
} from "../../../redux/slices/qrSettings";
import { DefaultLogoContext } from "../../../page/ThirdScreen";
import { getBase64Logo } from "../../../hooks/helpersThirdStep";

const ModalLogo = ({ setLogo }) => {
  const { setDefaultLogoData, setDefaultBackgroundImageData } =
    useContext(DefaultLogoContext);
  const { isLogoModal, lang, isBackgroundImageModal } = useSelector(
    (state) => ({
      isLogoModal: state.modals.isLogoModal,
      lang: state.changeLang.language.modalLogo,
      isBackgroundImageModal: state.modals.isBackgroundImageModal,
    })
  );
  const dispatch = useDispatch();
  const [selectedLogoId, setSelectedLogoId] = useState(null);

  const handleClose = () => {
    setSelectedLogoId(null);
    isLogoModal
      ? dispatch(setIsLogoModal(false))
      : dispatch(setIsBackgroundImageModal(false));
  };

  const titles = [lang[3], lang[4], lang[5], lang[6], lang[7]];

  const handleApply = async () => {
    if (setLogo) {
      setLogo(selectedLogoId);
    } else {
      const url = await getBase64Logo(selectedLogoId);
      if (isLogoModal) {
        dispatch(qrLogotype(selectedLogoId));
        setDefaultLogoData(url);
      } else if (isBackgroundImageModal) {
        dispatch(setBackgroundImage(selectedLogoId));
        setDefaultBackgroundImageData(url);
      }
    }

    handleClose();
  };

  return (
    <Modal show={true} onHide={handleClose} centered size="lg" scrollable>
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="text-capitalize">{lang[0]}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Accordion defaultActiveKey={[0]} alwaysOpen flush>
          {logoCategories.map((category, index) => {
            if (
              !defaultLogo.filter((item) => item.category === category).length
            )
              return null;

            return (
              <Accordion.Item
                key={category}
                eventKey={index}
                className="border-0"
              >
                <Accordion.Header>
                  <div className="text-dark fw-bold fs-8 text-capitalize">
                    {titles[index]}
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <Row className="g-2 g-lg-3">
                    {defaultLogo
                      .filter((item) => item.category === category)
                      .map((item) => (
                        <CustomCol xs={3} key={item.id}>
                          <FrameItem
                            onClick={() => setSelectedLogoId(item.id)}
                            className={classNames(
                              "d-flex justify-content-center align-items-center border rounded-1",
                              {
                                "border-primary": selectedLogoId === item.id,
                                "border-border-gray":
                                  selectedLogoId !== item.id,
                              }
                            )}
                            style={{ padding: "20%" }}
                          >
                            <img
                              src={item.img}
                              id={item.id}
                              className="img-fluid h-100"
                            />
                          </FrameItem>
                        </CustomCol>
                      ))}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            );
          })}
        </Accordion>
      </Modal.Body>
      <Modal.Footer className="d-block border-0">
        <Row className="gx-3 mt-4 gy-2 justify-content-lg-between">
          <Col xs={12} lg={4} className="order-1 order-lg-0 px-0">
            <Button
              variant="outline-dark"
              className="w-100 py-2 py-md-3 h-100 d-flex align-items-center justify-content-center"
              onClick={handleClose}
            >
              {lang[1]}
            </Button>
          </Col>
          <Col xs={12} lg={4} className="px-0">
            <Button
              className={classNames("w-100 fw-bold py-2 py-md-3 h-100", {
                "bg-border-gray border-border-gray": !selectedLogoId,
              })}
              disabled={!selectedLogoId}
              onClick={handleApply}
            >
              {lang[2]}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalLogo;
